// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index .bg[data-v-5c016c7c]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:-1}.index .return[data-v-5c016c7c]{color:#ff690e;font-size:3.704vw;margin:4.444vw 4.722vw}.index .return img[data-v-5c016c7c]{margin-right:1.481vw}.index .tit_img[data-v-5c016c7c]{text-align:center;margin:8.148vw 0 10.926vw}", ""]);
// Exports
module.exports = exports;
